module.exports = __webpack_public_path__ + "img/Icon ionic-ios-checkmark-circle-outline.c1ace571.svg";